/*global ActiveXObject*/

var config = require("../config.js");

function formatTime(date, showTime = true) {
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()

    var hour = date.getHours()
    var minute = date.getMinutes()
    var second = date.getSeconds()


    return [year, month, day].map(formatNumber).join('/') + ' ' + (showTime ? [hour, minute, second].map(formatNumber).join(':') : '')
}

//将字节转化成方便阅读的大小显示
function formatSize(b) {
    if (b < 1000) {
        return b + "B";
    }
    if (b < 1000 * 1000) {
        var n = b / 1000;
        return n.toFixed(0) + "KB";
    }

    var m = b / 1000 / 1000;
    return m.toFixed(2) + "MB";
}

function formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
}

function formatImage(url, avatar) {
    const theUrl = config.image() + '/' + url;
    if (avatar === 'original') {
        avatar = '';
        //return config.downloadImage + theUrl;
    }
    return theUrl + (avatar ? `!${avatar}` : '');
}

function findObjByKey(list, key, keyName = "key") {
    if (!list || !(list instanceof Array)) {
        return null;
    }
    return list.find((v) => {
        return v && (v[keyName] === key);
    })
};

function findObjIndexByKey(list, key, keyName = "key") {
    if (!list) {
        return -1;
    }
    return list.findIndex((v) => {
        return v && (v[keyName] === key);
    })
};

const debounce = function (func, wait = 800, immediate = true) {
    var timeout, args, context, timestamp, result;
    var later = function () {
        // 当wait指定的时间间隔期间多次调用_.debounce返回的函数，则会不断更新timestamp的值，导致last < wait && last >= 0一直为true，从而不断启动新的计时器延时执行func
        var last = new Date().getTime() - timestamp;

        if (last < wait && last >= 0) {
            timeout = setTimeout(later, wait - last);
        } else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            }
        }
    };

    return function () {
        context = this;
        args = arguments;
        timestamp = new Date().getTime();
        // 第一次调用该方法时，且immediate为true，则调用func函数
        var callNow = immediate && !timeout;
        // 在wait指定的时间间隔内首次调用该方法，则启动计时器定时调用func函数
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }

        return result;
    };
};


const throttle = function (func, wait = 800, options) {
    /* options的默认值
     *  表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
     *  options.leading = true;
     * 表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
     *  options.trailing = true;
     * 注意：当options.trailing = false时，效果与上面的简单实现效果相同
     */
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {leading: true, trailing: true};
    var later = function () {
        previous = options.leading === false ? 0 : new Date().getTime();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    return function () {
        var now = new Date().getTime();
        if (!previous && options.leading === false) previous = now;
        // 计算剩余时间
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        // 当到达wait指定的时间间隔，则调用func函数
        // 精彩之处：按理来说remaining <= 0已经足够证明已经到达wait的时间间隔，但这里还考虑到假如客户端修改了系统时间则马上执行func函数。
        if (remaining <= 0 || remaining > wait) {
            // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
            // options.trailing=true时，延时执行func函数
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
};

const flattern = function(arr) {
    var list = [];
    Object.keys(arr).forEach(key=>{
        list = list.concat(arr[key]);
    });
    return list;
}
// const pd = (e)=>{
//     e.preventDefault();
// }
// const preventScroll = ()=>{
//     document.addEventListener('touchmove',pd,{passive:false});
//     document.addEventListener('wheel',pd,{passive:false});
// }
// const disablePreventScroll = ()=>{
//     document.removeEventListener('touchmove',pd);
//     document.removeEventListener('wheel',pd);
// }
//求arr1和arr2的差集: arr1中有的，但是arr2中没有的部分
const arrDiff = function(arr1,arr2,cb){
    if(!arr1.length){
        return [];
    }
    let diff = [];
    arr1.forEach(one=>{
        //如果arr2中找不到就push进去
        let index = arr2.findIndex(element=>{
            let result;
            if(typeof cb === 'function'){
                result = cb(one,element)
            }else{
                result = one === element;
            }
            return result;
        })
        if(index === -1){
            diff.push(one);
        }
    })
    return diff;
}
module.exports = {
    arrDiff,
    formatTime: formatTime,
    formatImage: formatImage,
    findObjByKey,
    debounce,
    throttle,
    flattern,
    formatSize,
    setBar: (opt) => {
        let {title} = opt;
        title && (document.title = title);

        if(window.dd && typeof window.dd == 'object') {
            try {
                window.dd.biz.navigation.setTitle({
                    title:title
                });
            }catch(e) {

            }
        }

        if(window.appjs && typeof window.appjs == 'object') {
            if(window.appjs.updateTitle && typeof window.appjs.updateTitle == 'function') {
                window.appjs.updateTitle(title);
            }
        }
        //下面的方案本来是拿来修改IOS的微信的标题的，但是我的IOS11实测没有问题，如果其他iphone上有问题，请放开注释，并测试一下是否OK
        // if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
        //     var i = document.createElement('iframe');
        //     i.src = '/favicon.ico';
        //     i.style.display = 'none';
        //     i.onload = function() {
        //         setTimeout(function(){
        //             i.remove();
        //         }, 9)
        //     }
        //     document.body.appendChild(i);
        // }

        // wx.setNavigationBarColor({
        //   frontColor: opt.foreground,
        //   backgroundColor: opt.background,
        // })
    },
    isWeiyi:function() {
        if(window.appjs && typeof window.appjs == 'object') {
            if(window.appjs.updateTitle && typeof window.appjs.updateTitle == 'function' && window.appjs.getAppInfo && typeof window.appjs.getAppInfo == 'function') {
                return true;
            }
        }
        return false;
    },
    isWeb:function() {
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
                    "SymbianOS", "Windows Phone",
                    "iPad", "iPod", "MicroMessenger"];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > -1) {
                if(Agents[v] == 'MicroMessenger' && userAgentInfo.indexOf('WindowsWechat') > -1) {
                    // flag = true;
                }else {
                    flag = false;
                    break;
                }
            }
        }
        return flag;
    },
    isIphoneX:function() {
        return /iphone/gi.test(window.navigator.userAgent) &&
            (window.screen.height == 812 && window.screen.width == 375);
    },
    isIos:function(){
        return navigator.userAgent.indexOf('iPhone') > -1;
    },
    isFullScreen:function() {
        var isFullscreen = document.fullscreenEnabled ||
                            window.fullScreen ||
                            document.mozFullscreenEnabled ||
                            document.webkitIsFullScreen;
        return isFullscreen;
    },
    requestFullScreen:function(element) {
        element = element || document.documentElement;
        var requestMethod = element.requestFullScreen || //W3C
                            element.webkitRequestFullScreen || //Chrome等
                            element.mozRequestFullScreen || //FireFox
                            element.msRequestFullScreen; //IE11
        if (requestMethod) {
            requestMethod.call(element);
        }
        else if (typeof window.ActiveXObject !== "undefined") {//for Internet Explorer
            var wscript = new window.ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }
    },
    exitFullScreen:function() {
        var exitMethod = document.exitFullscreen || //W3C
                        document.mozCancelFullScreen || //Chrome等
                        document.webkitExitFullscreen || //FireFox
                        document.webkitExitFullscreen; //IE11
        if (exitMethod) {
            exitMethod.call(document);
        }
        else if (typeof window.ActiveXObject !== "undefined") {//for Internet Explorer
            var wscript = new window.ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }
    },
    isHtml : (string)=>/^<(\w+).*?(<\/\1>|\/>)$/g.test(string)
    // preventScroll,
    // disablePreventScroll,
}



// WEBPACK FOOTER //
// ./src/utils/util.js